<div class="elementCont" id="multiplechoicescont-{{ indexofelement }}">
    <div class="form-group form-group-custom-for-element">
      <div class="fontweight-700 overflowWrapAnywhere">
        <label for="" id="multiplechoicesLabel-{{ indexofelement }}" class="inpLabel " #multiplechoicesLabel>Checkbox</label>
      </div>
  
      <div id="multiplechoices-option-{{ indexofelement }}" class=" overflowWrapAnywhere" #multiplechoicesInp>
        <div class=" overflowWrapAnywhere">
          <input type="checkbox" value="" name="a-{{ indexofelement }}" />
          <label for="" class="mrgl-5 inpText subLabel">First</label>
        </div>
        <div class=" overflowWrapAnywhere">
          <input type="checkbox" value="" name="a-{{ indexofelement }}" />
          <label for="" class="mrgl-5 inpText subLabel">Second</label>
        </div>
      </div> 
      <div
        class="error-msg overflowWrapAnywhere"
        id="error-{{ indexofelement }}"
        #multiplechoicesError
      ></div>
    </div>
  

  </div>
  
